import { FuzzySearchResult } from '@tomtom-international/web-sdk-services';

import { IAddressPredictions } from 'pages/store-locator/context/types';

export const addressPredictionMapper = ({
  id,
  type,
  entityType,
  position,
  address,
}: FuzzySearchResult): IAddressPredictions => ({
  id: id || '',
  type: type || '',
  entityType,
  position: {
    lat: position?.lat || 0,
    lng: position?.lng || 0,
  },
  address: {
    streetNumber: address?.streetNumber || '',
    addressLine1: address?.streetName || '',
    city: address?.municipality || '',
    state: address?.countrySubdivision || '',
    zipCode: address?.postalCode || '',
    country: address?.country || '',
    addressline2: address?.localName || '',
  },
});
